/**
 * Единый контент верификации владельца номеров (mtt_verification).
 *
 * Источник истины для текста/кнопок — и для умного блока в окне покупки номеров
 * (modals/tel_add_number), и для верхней плашки (app.showAlerts). По info.action
 * (приходит из бэка: AlertService / LPT_Phone::random → MttGateService) показываем
 * ТОЛЬКО то, чего не хватает.
 *
 * 2026-09-03 (LPTRACKERDEV-1922): все дороги ведут на ОДНУ страницу /land/verification/.
 * Раньше плашка предлагала на выбор две-три кнопки («данные организации» / «паспорт»),
 * каждая вела на свою страницу, и каждая показывала свой статус — вплоть до прямых
 * противоречий (страница паспорта писала «на модерации», когда оператор связи данные
 * уже отклонил). Теперь клиент попадает на страницу, которая сама знает его состояние,
 * показывает причину отказа и даёт исправить ровно то, что можно исправить.
 *
 * @author @nesydbawa
 * @date   2026-06-26
 */
define(function () {
    'use strict';

    var VERIFY = '/land/verification/';          // единая страница верификации
    var QR     = '/land/test_id/qr.php';         // съёмка паспорта (мобильный поток)
    var ORG    = VERIFY;                         // старый адрес редиректит сюда же
    var STATUS = '/land/test_id/status.php';

    /**
     * @param {object} info  { action, missing:[{key,label}], type, status, reject_reason, ... }
     * @returns {{title:string, body:string, buttons:Array<{text,href}>}}
     */
    function getContent(info) {
        info = info || {};
        var action  = info.action || 'not_started';
        var missing = (info.missing || []).map(function (m) { return m.label; }).join(', ');
        var reason  = (info.reject_reason || '').toString().trim();
        var c = { title: '', body: '', buttons: [] };

        switch (action) {
            case 'pending':
                c.title = 'Данные получены — на модерации';
                if (info.notify_saved) {
                    // Контакты уже оставлены — форму не показываем, просто «ждите».
                    c.body = 'Идёт проверка (в рабочие дни, пн–пт). Как только аккаунт подтвердят, телефония включится — мы уведомим вас по оставленным контактам.';
                } else {
                    // Контактов ещё нет — предлагаем оставить телефон/телеграм для уведомления.
                    c.body = 'Идёт проверка (в рабочие дни, пн–пт). Оставьте контакты, и мы сразу сообщим, когда телефония включится.';
                    c.buttons = [{ text: 'Указать контакты для уведомления', modal: 'mtt_notify' }];
                }
                // Кнопка «Больше не показывать» — постоянно скрыть плашку (localStorage).
                c.buttons.push({ text: 'Больше не показывать', dismiss: true });
                break;
            case 'person_incomplete':
                c.title = 'Паспортная верификация не завершена';
                c.body  = 'Проверка по паспорту не завершена. Пройдите её заново или напишите в поддержку — поможем завершить.';
                c.buttons = [{ text: 'Пройти верификацию', href: VERIFY }];
                break;
            case 'org_incomplete':
                c.title = 'Не хватает данных организации';
                c.body  = 'Чтобы работать как организация, заполните недостающие данные' + (missing ? ': <b>' + missing + '</b>' : '') + '.';
                c.buttons = [{ text: 'Заполнить данные', href: VERIFY }];
                break;
            case 'ip_org_incomplete':
                c.title = 'ИП: не хватает данных организации';
                c.body  = 'Заполните недостающие данные организации' + (missing ? ': <b>' + missing + '</b>' : '') + '. Для ИП по закону «О связи» также нужна паспортная верификация владельца.';
                c.buttons = [{ text: 'Заполнить данные', href: VERIFY }];
                break;
            case 'ip_passport_needed':
                c.title = 'Осталась паспортная верификация';
                c.body  = 'Данные организации приняты. Для ИП по закону «О связи» нужна ещё паспортная верификация владельца.';
                c.buttons = [{ text: 'Пройти паспортную верификацию', href: VERIFY }];
                break;
            case 'rejected':
                c.title = 'Оператор связи отклонил данные';
                // Причину отказа знает только оператор — показываем её дословно, иначе
                // клиент видит «переоформите» и не понимает, что именно не так.
                c.body  = reason
                    ? 'Причина: <b>' + reason + '</b>. Откройте страницу верификации — там видно, что именно исправить.'
                    : 'Верификация отозвана оператором связи. Откройте страницу верификации — там указана причина и что нужно исправить.';
                c.buttons = [{ text: 'Посмотреть и исправить', href: VERIFY }];
                break;
            default: // not_started — коротко, одна кнопка
                c.title = 'Подтвердите личность владельца номеров';
                c.body  = 'По закону «О связи» каждый номер должен кому-то принадлежать. Откройте страницу верификации — она подскажет, что нужно именно вам: паспорт или данные организации.';
                c.buttons = [{ text: 'Пройти верификацию', href: VERIFY }];
        }
        return c;
    }

    return { getContent: getContent, VERIFY: VERIFY, QR: QR, ORG: ORG, STATUS: STATUS };
});
